// Copyright (c) 2017 Deere & Company

import TcsmWipContainer from '../../tcsm/wip';
import laborRateApproval from './labor-rate-approval';
import spaDetails from './spa';

export default {
    childRoutes: [
        laborRateApproval,
        spaDetails
    ],
    component: TcsmWipContainer,
    name: 'WIP',
    path: 'wip'
};




// WEBPACK FOOTER //
// ./src/routes/tcsm/wip.js